import React, { useMemo } from "react";
import RegisterPage, { STATUS_BADGES, StatCard } from "../components/RegisterPage";
import { useHSE } from "../lib/store";
import { getExpiryStatus } from "../lib/hseCalc";

export default function EquipmentCertification() {
  const { data } = useHSE();
  const rows = useMemo(
    () => (data.equipment || []).map((r) => ({ ...r, status: getExpiryStatus(r.expiryDate) })),
    [data.equipment]
  );

  const valid = rows.filter((r) => r.status === "Valid").length;
  const expiring = rows.filter((r) => r.status === "Expiring Soon").length;
  const expired = rows.filter((r) => r.status === "Expired").length;

  const Top = (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <StatCard label="Total Equipment" value={rows.length} testid="eq-total" />
      <StatCard label="Valid" value={valid} tone="safe" testid="eq-valid" />
      <StatCard label="Expiring Soon" value={expiring} tone="warning" testid="eq-expiring" />
      <StatCard label="Expired" value={expired} tone="critical" testid="eq-expired" />
    </div>
  );

  return (
    <RegisterPage
      title="Equipment & Certification Register"
      subtitle="TPI / third-party certificates — cranes, MEWPs, lifting gear, extinguishers, tools & operators"
      storeKey="equipment"
      idPrefix="EQ"
      topPanels={Top}
      columns={[
        { key: "id", label: "Eq ID" },
        { key: "type", label: "Equipment Type" },
        { key: "serial", label: "Serial No" },
        { key: "contractor", label: "Owner / Contractor" },
        { key: "certificateNo", label: "Certificate No" },
        { key: "issueDate", label: "Issued" },
        { key: "expiryDate", label: "Expiry" },
        { key: "status", label: "Status" },
      ]}
      badgeMap={{ status: STATUS_BADGES }}
      formFields={[
        { key: "id", label: "Equipment ID" },
        { key: "type", label: "Equipment Type", type: "select", options: data.settings.equipmentTypes || [] },
        { key: "serial", label: "Serial Number" },
        { key: "contractor", label: "Contractor / Owner" },
        { key: "certificateNo", label: "Certificate No" },
        { key: "issueDate", label: "Issue Date", type: "date" },
        { key: "expiryDate", label: "Expiry Date", type: "date" },
        { key: "status", label: "Status", type: "select", options: ["Valid", "Expiring Soon", "Expired"] },
      ]}
    />
  );
}
